module.exports = __webpack_public_path__ + "static/media/energetica.f12c1934.png";